import safetyItems from './commercial/_safety';
import handWashingItems from './commercial/_handwashing';
import industrialItems from './commercial/_industrial';
import foodItems from './commercial/_food';

export const heater = 'heater';
export const tankless = 'tankless';
export const needHelp = 'need-help';
export const callUs = 'call-us';
export const selectCabinet = 'select-cabinet';
export const finalResultWithCabinet = 'final-result-with-cabinet';
export const selectCabinetOptions = 'select-cabinet-options';

export const switchToResidential = 'switch-to-residential';

const commercialStart = 'commercial-start';
const commercialResidential = 'commercial-residential';
const branchSafety = 'branch-safety';
const branchHandwashing = 'branch-handwashing';
const branchIndustrial = 'branch-industrial';
const branchFood = 'branch-food';

const stepMap = 'map';
const stepSelectBranch = 'select-branch';
const is3PhasePower = 'is-3-phase-power';

export default [
  {
    id: commercialStart,
    step: 'Who are you?',
    component: 'Selector',
    title: 'Welcome to the Eemax Sizing Wizard for Commercial Applications!',
    dopLabel: 'Who are you?',
    tip: '<b>Note</b>: The fixtures selected in the following pages should represent the maximum amount of water that would be running simultaneously. These fixtures are close to the unit and do not represent the TOTAL amount of fixtures needed for the whole system unless applicable.',
    options: [
      { title: 'Homeowner', value: '1', nextId: switchToResidential },
      { title: 'Agency/Distributor', value: '2', nextId: commercialResidential },
      { title: 'Contractor (Electrician/Plumber)', value: '3', nextId: commercialResidential },
      { title: 'Engineer/Architect', value: '4', nextId: commercialResidential },
    ],
  },
  {
    id: commercialResidential,
    step: 'Which are you sizing for?',
    component: 'SelectorComRes',
    nextId: stepMap,
  },
  {
    id: stepMap,
    step: 'Map',
    component: 'Map',
    nextId: stepSelectBranch,
    prevId: null,
    paramName: 'temp-in',
  },
  {
    id: stepSelectBranch,
    step: 'Application Detail',
    component: 'Selector',
    title: 'Please choose your application detail:',
    options: [
      {
        title: 'Safety', params: { application: ['safety'] }, value: '1', nextId: `${branchSafety}_${is3PhasePower}`,
      },
      { title: 'Handwashing', value: '2', nextId: `${branchHandwashing}_${is3PhasePower}` },
      { title: 'Industrial', value: '3', nextId: `${branchIndustrial}_requirements` },
      { title: 'Food Service/Hospitality', value: '4', nextId: `${branchFood}_requirements` },
      { title: 'Sanitation', value: '5', nextId: `${branchFood}_sanitation_${is3PhasePower}` },
    ],
  },
  // branch Safety
  ...safetyItems,
  // branch Handwashing
  ...handWashingItems,
  // branch Industrial
  ...industrialItems,
  // branch Food
  ...foodItems,
  // Need Help etc.
  {
    id: needHelp,
    step: 'Need Help',
    component: 'NeedHelp',
  },
  {
    id: callUs,
    step: 'Call',
    component: 'Call',
  },
  {
    id: selectCabinet,
    step: 'Cabinet Options',
    component: 'SelectorCabinet',
  },
  {
    id: selectCabinetOptions,
    step: '3ph Additional Options',
    component: 'Selector',
    multiple: true,
    options: [
      { title: 'Freeze Protection (-30°F)', value: 'FP' },
      { title: 'Non-fused Disconnect', value: 'EDS' },
      { title: 'Fused Disconnect', value: 'FDS' },
      { title: 'Explosion Proof (C1D2 compliant)', value: 'EP' },
      { title: 'True RMS GFCI with digital display & reset', value: 'GFCI' },
      { title: 'Dry Contact', value: 'DC' },
      { title: 'Siren & Beacon', value: 'SB' },
      { title: '24” legs for free standing unit', value: 'SK' },
      { title: 'Emergency Stop (push button)', value: 'ES' },
      { title: 'Remote Display (on outside of cabinet)', value: 'RD' },

    ],
    nextId: finalResultWithCabinet,
  },
  {
    id: finalResultWithCabinet,
    step: 'Result with options',
    component: 'Result',
    withCabinet: true,
  },
];
